export default __webpack_public_path__ + "static/media/check-mark.b36d84b8.png";